import { render } from "./Precificacoes.vue?vue&type=template&id=4176c4dc&scoped=true"
import script from "./Precificacoes.vue?vue&type=script&lang=js"
export * from "./Precificacoes.vue?vue&type=script&lang=js"

import "./Precificacoes.vue?vue&type=style&index=0&id=4176c4dc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4176c4dc"]])

export default __exports__